import { z } from "zod";
import { numberSerieSchema } from "./Numberserie";
import { carrierDocumentSchema } from "./CarrierDocument";

const carrierSchemaBase = z.object({
  carrierId: z.string().max(50),
  carrierSuiteId: z.string().max(50),
  name: z.string().max(50),
  gaNo: z.string().max(50).optional(),
  pallRegNo: z.string().max(50).optional(),
  consolidate: z.boolean().optional(),
  uNBaddressOwn: z.string().max(50).optional(),
  uNBqualifierOwn: z.string().max(50).optional(),
  uNBaddressRec: z.string().max(50).optional(),
  uNBqualifierRec: z.string().max(50).optional(),
  fTPserver: z.string().max(50).optional(),
  fTPport: z.number().optional(),
  fTPaccount: z.string().max(50).optional(),
  fTPpassword: z.string().max(50).optional(),
  usePassiveFtp: z.boolean().optional(),
  ws_UserName: z.string().max(1024).optional(),
  ws_Password: z.string().max(3000).optional(),
  transferProtocol: z.enum(["FTP", "SFTP"]).optional(),
  documents: z.array(carrierDocumentSchema),
  testMode: z.boolean(),
})

const carrierSchemaWithoutNumberseries = carrierSchemaBase.extend({
  consNoFromAPI: z.literal(true),
  pkgNoFromAPI: z.literal(true),
  numberSeries: z.object({
    consignment: numberSerieSchema.optional(),
    package: numberSerieSchema.optional()
  })
})
const carrierSchemaWithoutPgkNo = carrierSchemaBase.extend({
  consNoFromAPI: z.literal(false),
  pkgNoFromAPI: z.literal(true),
  numberSeries: z.object({
    consignment: numberSerieSchema,
    package: numberSerieSchema.optional()
  })
})
const carrierSchemaWithoutConsNo = carrierSchemaBase.extend({
  consNoFromAPI: z.literal(true),
  pkgNoFromAPI: z.literal(false),
  numberSeries: z.object({
    consignment: numberSerieSchema.optional(),
    package: numberSerieSchema
  })
})
const carrierSchemaWithNumberseries = carrierSchemaBase.extend({
  consNoFromAPI: z.literal(false),
  pkgNoFromAPI: z.literal(false),
  numberSeries: z.object({
    consignment: numberSerieSchema,
    package: numberSerieSchema
  })
})

export const carrierSchema = z.union([carrierSchemaWithoutNumberseries, carrierSchemaWithoutConsNo, carrierSchemaWithoutPgkNo, carrierSchemaWithNumberseries])


export type CarrierType = z.infer<typeof carrierSchema>;